document.addEventListener( 'DOMContentLoaded', function() {
  new Splide( '#box3-splide' ).mount();
  new Splide( '#mira-box2-splide' ).mount();
  new Splide( '#mira-box5-splide',{
    perPage: 3,
    omitEnd: true,
    gap: 10,
    breakpoints: {
      750: {
        perPage: 1,
      },
    },
  } ).mount();

  function indicator(e){
    marker.style.left = e.offsetLeft + 'px';
    marker.style.width = e.offsetWidth + 'px';
  }

  let marker = document.querySelector("#marker2");
  let tabItem = document.querySelectorAll(".assembly-box2-tab a");
  let tabItemContent = document.querySelectorAll(".assembly-box2-tab-c-item");
  tabItem.forEach((link,index) => {
  
    link.addEventListener('click', (e)=>{
      indicator(e.target)
  
      tabItemContent.forEach(item => {
        item.classList.remove("assembly-box2-active");
      })
      tabItem.forEach(item => {
        item.classList.remove("assembly-box2-tab-active");
      })
  
      tabItem[index].classList.add("assembly-box2-tab-active");
      tabItemContent[index].classList.add("assembly-box2-active");
    })
  
    link.addEventListener('mouseover', (e)=>{
      indicator(e.target)
  
      tabItemContent.forEach(item => {
        item.classList.remove("assembly-box2-active");
      })
      tabItem.forEach(item => {
        item.classList.remove("assembly-box2-tab-active");
      })
  
      tabItem[index].classList.add("assembly-box2-tab-active");
      tabItemContent[index].classList.add("assembly-box2-active");
    })
  
  })
} );